@if(auth.hasProfile() && !onMaintenancePage() && !onBarePage()){
<div class="layout-grid"
     [class.sidebar-expanded]="sidebarMode === 'expanded'"
     [class.sidebar-collapsed]="sidebarMode === 'collapsed'"
     [class.sidebar-closed]="sidebarMode === 'closed'">

  <!-- Sidebar gauche — pleine hauteur, collée au bord gauche -->
  <div class="navigation">
    <app-sidenav-v2 [mode]="sidebarMode" (modeChange)="onSidebarModeChange($event)"></app-sidenav-v2>
  </div>

  <!-- Header — uniquement dans la zone contenu droite -->
  <div class="content-header">
    @if (connectivity.offline()) {
      <div class="offline-banner" role="status">
        Vous êtes hors ligne — les modifications ne seront pas enregistrées
      </div>
    }
    <app-header [sidebarMode]="sidebarMode" (menuToggle)="onSidebarModeChange('expanded')" />
    <app-trial-ending-banner />
  </div>

  <!-- Zone de contenu principale, scrollable -->
  <div class="content-main">
    <div class="content-inner">
      <router-outlet></router-outlet>
    </div>
  </div>

  <!-- Sidebar secondaire droite (détails) — comportement inchangé -->
  <div class="sidebar-right-container" [class.open]="showRightSidebar()" [class.closed]="!showRightSidebar()">
    @if(showRightSidebar()) {
      <div class="sidebar-overlay" (click)="rightSidebarService.close()"></div>
    }
    <!-- Mobile : plein écran modal (role=dialog, focus piégé) ; glisser vers la droite le ferme. -->
    <div class="sidebar-right-panel" [style.width.px]="rightPanelWidth()" [style.min-width.px]="rightPanelWidth()"
         [attr.role]="isMobile() ? 'dialog' : null"
         [attr.aria-modal]="isMobile() && showRightSidebar() ? 'true' : null"
         [attr.aria-label]="isMobile() ? 'Panneau de détails' : null"
         [attr.inert]="showRightSidebar() ? null : ''"
         [cdkTrapFocus]="isMobile() && showRightSidebar()"
         [cdkTrapFocusAutoCapture]="true"
         [appSwipeClose]="isMobile() && showRightSidebar()"
         (swipeClose)="rightSidebarService.close()">
      <div class="sidebar-right-content">
        <router-outlet name="sidebar"></router-outlet>
      </div>
    </div>
  </div>
</div>
}
@else{
  <router-outlet></router-outlet>
}

@if ((updateAvailable$ | async) && !onRoomScreen()) {
<div class="update-banner">
  Une nouvelle version est disponible.
  <button (click)="updateApplication()">Mettre à jour</button>
</div>
}

<app-toast-container />
<app-shortcuts-help />
<app-undo-snackbar />
<app-legal-consent-gate />

<!--
  Assistant conversationnel — monté À LA RACINE, hors de `.layout-grid` : rendu
  dans le header il héritait du stacking context `.content-header` (z-index 50),
  donc il passait sous `.navigation` (z-index 100) quand la fenêtre est étroite.
-->
<app-voice-assistant-overlay [open]="voiceOverlay.isOpen()" (closed)="voiceOverlay.close()" />
